<template>
    <modal-live ref="modal">
        <div class="modal-header">
            <h3 class="headline--modal">Send Feedback</h3>
            <span class="modal__icon-close" @click="dismiss()">
                <svg>
                    <use :xlink:href="`${icons['close']}#icon`"></use>
                </svg>
            </span>
        </div>
        <div class="dialog">
            <hgroup>
                <h2 class="headline--welcome text-center">
                    Please help us improve Hammer
                </h2>
                <h3 class="headline--subtitle text-center">
                    Found a bug? Have an idea a new feature?
                </h3>
            </hgroup>
            <div class="modal-scrollable">
                <div style="padding-bottom: 40px">
                    <input-textarea
                        class="input--high"
                        v-model="message"
                        name="message"
                        :placeholder="'Your message (required)'"
                        :required="true"
                    ></input-textarea>
                </div>
                <div class="d-flex" style="padding-bottom: 30px">
                    <div class="flex-fill">
                        <input-text
                            class="input--high"
                            v-model="email"
                            name="email"
                            :placeholder="'Email'"
                            :required="true"
                        ></input-text>
                    </div>
                    <div style="min-width: 18px"></div>
                    <div class="flex-fill">
                        <input-text
                            class="input--high"
                            v-model="phone"
                            name="phone"
                            :placeholder="'Phone Number'"
                            :required="true"
                        ></input-text>
                    </div>
                </div>
            </div>
            <div v-if="error.show">
                <div
                    class="error__wrapper alert alert-danger text-center"
                    role="alert"
                >
                    <strong>{{ error.msg }}</strong>
                </div>
            </div>
            <div class="text-center pt-3">
                <Button
                    @click.native="send()"
                    class="text-sm btn-block"
                    :disabled="isDisabled"
                >
                    <svg class="button__icon">
                        <use :xlink:href="`${icons['send']}#icon`"></use>
                    </svg>
                    Submit
                </Button>
            </div>
        </div>
    </modal-live>
</template>

<script>
export default {
    computed: {
        isDisabled() {
            return !this.isValid;
        },
        isValid() {
            /* eslint-disable */
            return this.message && this.email && this.phone;
            /* eslint-enable */
        },
    },
    data() {
        return {
            icons: window.here.icons,
            message: null,
            email: null,
            phone: null,
            error: {
                show: false,
                msg: '',
            },
        };
    },
    methods: {
        dismiss() {
            this.$refs.modal.dismiss();
        },
        send() {
            axios
                .post('/api/v1/feedback/send', {
                    message: this.message,
                    email: this.email,
                    phone: this.phone,
                })
                .then(() => {
                    this.dismiss();
                })
                .catch(({ response }) => {
                    const {
                        data: { errors },
                    } = response;
                    if (errors) {
                        let errorMsg = '';
                        Object.keys(errors).forEach((key) => {
                            let inputWrapper = document.querySelector(
                                `[name="${key}"] .input-text__wrapper`,
                            );
                            if (!inputWrapper) {
                                inputWrapper = document.querySelector(
                                    `[name="${key}"] .input-textarea__wrapper`,
                                );
                            }
                            inputWrapper.classList.add('error', 'shake');
                            setTimeout(() => {
                                inputWrapper.classList.remove('shake');
                            }, 820);
                            errorMsg += `${errors[key][0]}\n`;
                        });
                        this.error = {
                            show: true,
                            msg: errorMsg,
                        };
                    } else {
                        this.error = {
                            show: true,
                            msg: 'Something went wrong. Try again',
                        };
                    }
                });
        },
    },
};
</script>

<style lang="scss">
.button__icon {
    width: 24px;
    height: 24px;
}
.error__wrapper {
    strong {
        white-space: break-spaces;
    }
}
</style>
